import ErrorModal from "./errorModal";
import { useNavigate } from "react-router";

const Page404 = () => {
  const navigate = useNavigate();
  document.title = "Page Not Found";
  return (
    <ErrorModal
      title="Page not found"
      description="Page could not be found, Please make sure you have correctly entered the URL and try again"
      onRetry={() => navigate("/")}
      retryButtonText={"Go to Homepage"}
    />
  );
};

export default Page404;
